import { render, staticRenderFns } from "./tableModel.vue?vue&type=template&id=dec84c88"
import script from "./tableModel.vue?vue&type=script&lang=js"
export * from "./tableModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec84c88')) {
      api.createRecord('dec84c88', component.options)
    } else {
      api.reload('dec84c88', component.options)
    }
    module.hot.accept("./tableModel.vue?vue&type=template&id=dec84c88", function () {
      api.rerender('dec84c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/components/tableModel.vue"
export default component.exports